





































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue';
import ApiClient from '@/data/ApiClient';
import notificationService from '@/services/notificationService';
import DxFileUploader from 'devextreme-vue/file-uploader';
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxLabel,
  DxRequiredRule,
} from 'devextreme-vue/form';

@Component({
  components: {
    DxPopup,
    DxToolbarItem,
    DxScrollView,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxLabel,
    DxRequiredRule,
    DxFileUploader,
  },
})
export default class UploadSignedContractPopup extends Vue {
  @Prop({required: true})
  private documentNumber!: string;

  private showPopup: boolean = false;
  private guidList: any[] = [];

  public open() {
    this.showPopup = true;
  }

  public hide() {
    this.showPopup = false;
  }

  private async uploadChunk(file: any, uploadInfo: any) {
    try {
      const item = this.guidList.find((i) => i.name === file.name);

      const dto: IUploadChunkDto = {
        file: uploadInfo.chunkBlob,
        path: '',
        metaData: {
          index: uploadInfo.chunkIndex,
          totalCount: uploadInfo.chunkCount,
          fileSize: file.size,
          fileType: file.type,
          fileName: file.name,
          fileGuid: item ? item.guid : '',
        },
      };

      const result = (await ApiClient.projects.contracts.document.upload(this.documentNumber, dto)).data;

      const guidItems = this.guidList.filter((guidItem) => guidItem.name === file.name);
      if (guidItems.length > 0) {
        if (result.completed) {
          guidItems.forEach((guidItem) => {
            const index = this.guidList.indexOf(guidItem);
            this.guidList.splice(index, 1);
          });
        }
      } else {
        if (!result.completed) {
          this.guidList.push({
            name: file.name,
            guid: result.guid,
          });
        }
      }

      if (result.completed) {
        notificationService.showSuccessMessage('Bestand is geüpload');
        this.$emit('uploaded');
        this.hide();
      }
    } catch (err) {
      notificationService.showErrorMessage('Er is iets misgelopen tijdens het uploaden');
    }
  }
}
